<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">
    <b-row class="justify-content-center marginalbotsm">
        <b-col cols="auto">
            <b-button @click="activePlugin = 'noDRM'" :variant="(activePlugin === 'noDRM') ? 'greenw':'msstreamblue'">{{$ml.get('examplenodrm')}}</b-button>
            &nbsp;
            <b-button @click="activePlugin = 'withDRM'" :variant="(activePlugin !== 'noDRM') ? 'greenw':'msstreamblue'" >{{$ml.get('exampledrm')}}</b-button>
        </b-col>
    </b-row>
    <b-row class="mt-2">
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Hls.js and integrating **QUANTEEC** without DRM.
```html
&lt;head>
    &lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;video id="videoplayer" width="854" height="480" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.m3u8";
            
            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };

            var videoPlayer = document.getElementById("videoplayer");

            var hlsPlayer = new Hls();

            // 3-Link QUANTEEC to hls.js right *after* the creation of the hls player instance
            var quanteecPlayer = new Quanteec(configQuanteec, hlsPlayer);

            hlsPlayer.loadSource(videoSource);
            hlsPlayer.attachMedia(videoPlayer);
            hlsPlayer.on(Hls.Events.MANIFEST_PARSED, function() {
                videoPlayer.play();
            });
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>

    <vue-markdown :show="activePlugin === 'withDRM'" style="overflow: auto;" class="col-7" :style="(activePlugin === 'noDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Hls.js and integrating **QUANTEEC** with DRM. Only Widevine DRM is supported. More information can be found [here](https://github.com/video-dev/hls.js/blob/master/docs/API.md#widevineLicenseUrl).
```html
&lt;head>
    &lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;video id="videoplayer" width="854" height="480" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.m3u8";
            
            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };

            var videoPlayer = document.getElementById("videoplayer");

            var hlsPlayer = new Hls({
                        emeEnabled: true, // For DRM
                        widevineLicenseUrl: "URL_TO_LICENSE_SERVER", // For DRM
                    });

            // 3-Link QUANTEEC to hls.js right *after* the creation of the hls player instance
            var quanteecPlayer = new Quanteec(configQuanteec, hlsPlayer);

            hlsPlayer.loadSource(videoSource);
            hlsPlayer.attachMedia(videoPlayer);
            hlsPlayer.on(Hls.Events.MANIFEST_PARSED, function() {
                videoPlayer.play();
            });
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
    </b-row>
</b-col>
</b-row>
</b-container>

</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';

import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Hlsjs',
  data: function() {
    return {
     activePlugin:"noDRM",
     
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
      onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>